import React, { useState, useEffect, useRef } from "react";
import  BreadcrumbPage  from "../Common/CommonSections/Breadcrum";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import axios from "axios";
import Col from 'react-bootstrap/Col';
import Style from '../Styles/Common.module.css';
import Button from '../Styles/Button.module.css';
import { Link } from "react-router-dom";
import { IoMdClose } from "react-icons/io";
import LoginPopup from "../Common/Login/UserLogin";
import { useSelector } from 'react-redux';
import {getOffersListFormData,getCountryListFormData,getStateListByCountryId,getCityListByStateId} from '../../services/routes.services';
import constants from '../../services/constants'
import PlaceholderImage from '../../assest/images/no-img.jpg';  // Add a placeholder image

const OfferPage= ()=>{
    //Login Popup
    const [loginShow, setLoginShow] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [offerData, setOfferData] = useState([]);
    const [lastofferData, setLastOfferData] = useState([]);
    const [itemsPerPage, setItemsPerPage] = useState(6);
    const [currentPage, setCurrentPage] = useState(1);
    const [popupData ,setPopupData] =useState('');
    const [countryOptions, setCountryOptions] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    const [countryFilter, setCountryFilter] = useState('');
    const [countrydropdownFilter, setCountrydropdownFilter] = useState('');
    const [stateFilter, setStateFilter] = useState('');
    const [statedropdownFilter, setStatedropdownFilter] = useState('');
    const [cityFilter, setCityFilter] = useState('');
    const [sortOrder, setSortOrder] = useState(''); // State for sorting order
    const [showOffer, setShowOffer]= useState(false);
    const [sendRequest, setSendRequset] = useState(false)
    const { isAuthenticated ,token} = useSelector((state) => state.auth);
    const sectionPageingScroll = useRef(null);
    const scrollToSection = (ref) => {
        if (ref && ref.current) {
            ref.current.scrollIntoView({ behavior: "smooth" });
        } else {
            console.error("Ref is not attached to a DOM element");
        }
    };
    const offerRequestHandler=()=>{
        setShowOffer(true)
    }
    const closeOfferPop=()=>{
        setShowOffer(false)
        setSendRequset(false)
    }
    const sendRequsetHandler=async(data)=>{
        const apiEndpoint = `${constants.API_BASE_URL}offer/avail-offer/${data._id}`; // Replace with your API URL
   

    try {
      const response = await axios.post(apiEndpoint, data._id, {
        headers: { "Content-Type": "multipart/form-data",'Authorization': `Bearer ${token}` },
      });

      setSendRequset(true)
     
    } catch (error) {
      console.error("Error submitting CV:", error.response?.data || error.message);
     
    } 
        
    }

    const loginCloseHandler = ()=>{
            setLoginShow(false)
    }
    useEffect(()=>{
        if(isAuthenticated === true){
            getOffersDetails()
        }
        if(isAuthenticated === false){
            setLoginShow(true)
        }
        
    }, [isAuthenticated]);
    const getOffersDetails=()=>{
        getOffersListFormData(token)
        .then((res) => {
            var offerData =res.data.offers;
            setOfferData(offerData);
            const lastSixOffers = offerData.length > 0 ? offerData.slice(-6) : [];
           
            setLastOfferData(lastSixOffers);
        })
        .catch((error) => {
            console.log(error);
        });
        getCountryListFormData()
        .then((res) => {
          const  dataCountry=res.data.countries;
            setCountryOptions(dataCountry);
            // [...new Set(dataCountry.map(country => country.name))]
        })
        .catch((error) => {
            console.log(error);
        });
    }
    const [offerPopup, setOfferPopup] = useState(false);
   
    const shoeOfferPopHandler=(data)=>{
        setOfferPopup(true)
        setPopupData(data)
    }
    const closeOfferHandler = ()=>{
        setOfferPopup(false)
    }
    // offerData
    
    const handleCountryChange = (e) => {
        const selectedCountryId = e.target.value;
        const selectedCountryName = e.target.options[e.target.selectedIndex].getAttribute('data-countryname');
     
        
        setCityOptions([])
        
         // Fetch states based on selected country
         if(selectedCountryId!==''){
            getStateListByCountryId(selectedCountryId)
        .then((res) => {
            const dataState=res.data;
            setStateOptions(dataState);
         
           
        })
        .catch((error) => {
            console.log(error);
        });
    }
    setCountrydropdownFilter(selectedCountryId)
        setCountryFilter(selectedCountryName);
    };

    const handleStateChange = (e) => {
        const selectedState = e.target.value;
        const selectedStateName = e.target.options[e.target.selectedIndex].getAttribute('data-stateyname');
     
        
        if(selectedState!==''){
        // Fetch cities based on selected state
        getCityListByStateId(selectedState)
        .then((res) => {
            const dataCity=res.data;
            setCityOptions(dataCity);
        })
        .catch((error) => {
            console.log(error);
        });
    }
    setStatedropdownFilter(selectedState)
        setStateFilter(selectedStateName);
    };
    const handleCityChange = (e) => {
        const selectedCityName = e.target.options[e.target.selectedIndex].getAttribute('data-cityname');
     
        setCityFilter(selectedCityName);
    };
   // Handle sort change
const handleSortChange = (e) => {
    setSortOrder(e.target.value); // Update the sort order
};
const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
};
    const filteredOffers = offerData.filter((offer) => {
        const isCountryMatch = countryFilter === '' || offer.country === countryFilter;
        const isCityMatch = cityFilter === '' || offer.city === cityFilter;
        // const matchSearchByDes = searchQuery
        // ? offer.offerDescription.toLowerCase().includes(searchQuery.toLowerCase())
        // : true;
        const matchSearch = searchQuery
        ? offer.category?.toLowerCase().includes(searchQuery.toLowerCase())
        : true;
        return isCountryMatch  && isCityMatch && matchSearch ;
    });
    
    // Sort offers based on sortOrder (latest or oldest)
    const sortedOffers = filteredOffers.sort((a, b) => {
        if (sortOrder === 'latest') {
            return new Date(b.batch) - new Date(a.batch);
        } else if (sortOrder === 'oldest') {
            return new Date(a.batch) - new Date(b.batch);
        } else {
            return 0; // No sorting if no sortOrder is selected
        }
    });
      // Calculate total pages and current offers
      const totalPages = Math.ceil(sortedOffers.length / itemsPerPage);
      const currentOffers = sortedOffers && sortedOffers.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
      const handlePageChange = (pageNumber) => {
        scrollToSection(sectionPageingScroll);
        setCurrentPage(pageNumber);
    };

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(e.target.value);
        setCurrentPage(1); // Reset to first page
    };
    const resetdata=()=>{
        setStatedropdownFilter('')
        setCountrydropdownFilter('')
        setCityFilter('')
         setCountryFilter('');
    setStateFilter('');
    setStateOptions([]);   // Clear dependent states
    setCityOptions([]);    // Clear dependent cities
    setSearchQuery('');    // Optional: clear search
    setSortOrder('');      // Optional: clear sorting
    setCurrentPage(1);     // Optional: reset pagination
    }
    
    return(
        <div>
            {isAuthenticated ? 
             <div>
                <BreadcrumbPage home="Home" listOne="Offers" />
                <div className={Style.pageTitle + ' ' + Style.componentsSpace}>
                    <Container>
                        <Row>
                            <Col>
                                <div className={Style.sectionTitle}>
                                    <h2>Offers</h2>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className={Style.pageSubTitle}>
                                    <h3>NEW LISTINGS</h3>
                                  
                                    <ul className={Style.newlisting}>
                                        {lastofferData && lastofferData.map((item,i)=>{
                                            return(
                                            <li key={i}>
                                                <button type="button" onClick={()=>shoeOfferPopHandler(item)}>
                                                    <figure>
                                                        {item.image && item.image!=='undefined' ?
                                                        (<img src={constants.IMAGE_BASE_URL+"business/"+item.image} alt={item.package} />):(<img src={PlaceholderImage} alt={item.package} />)
                                                }</figure>
                                                    <h3>{item.package}</h3>
                                                    <span>{item.category}</span>
                                            </button>
                                        </li>
                                            )
                                        })}
                                       
                                    </ul>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col className={Style.searchArea + ' ' + Style.postffer}>
                                <div className={Style.searchContainer}>
                                    <div className={Style.postButton}>
                                        <Link to="/offer-create" className={Button.greenBtn}>Post Your Offer</Link>
                                    </div>
                                    <div className={Style.searchInput}>
                                        <input type="text"  value={searchQuery}
                                    onChange={handleSearchChange}
                                   />
                                        <button type="button">Search</button>
                                    </div>
                                    <div className={Style.byYear}>
                                    <select onChange={handleSortChange} >
                                            <option value="">Sort By</option>
                                            <option value="latest">Latest</option>
                                            <option value="oldest">Oldest</option>
                                            
                                        </select>
                                        <select  onChange={handleItemsPerPageChange}>
                                            <option value="6">Page Size</option>
                                            <option value="20">Show 20 </option>
                                            <option value="50">Show 50</option>
                                            <option value="100">Show 100</option>
                                            
                                        </select>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className={Style.elementPadding80}>
                                    <Row>
                                        <Col md={2} className={Style.width100}>
                                            <div className={Style.FliterSection}>
                                                <div className={Style.filterHead}>
                                                  
                                                    <button onClick={()=>resetdata()} type="button">Reset</button>
                                                </div>
                                                <div className={Style.filterSelect}>
                                                <select value={countrydropdownFilter} onChange={(e)=>handleCountryChange(e)}>
                                                        <option value="">Select Country</option>
                                                    
                                                        {countryOptions && countryOptions.map(country => (
                                                            <option key={country.id} value={country.id} data-countryname={country.name}>{country.name}</option>
                                                        ))}
                                                    </select>
                                                    <select value={statedropdownFilter} onChange={(e)=>handleStateChange(e)}>
                                                        <option value="">Select State</option>
                                                    
                                                        {stateOptions && stateOptions.map(state => (
                                                            <option key={state.id} value={state.id} data-stateyname={state.name}>{state.name}</option>
                                                        ))}
                                                    </select>
                                                    <select value={cityFilter} onChange={(e)=>handleCityChange(e)}>
                                                        <option value="">Select City</option>
                                                    
                                                        {cityOptions.map(city => (
                                                            <option key={city.id} value={city.name} data-cityname={city.name}>{city.name}</option>
                                                        ))}
                                                    </select>
                                                    
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={10} className={Style.width100}>
                                            <Row>
                                                
                                                {currentOffers && currentOffers.map((item, i) => {
                                                    return(
                                                        <Col md={6} key={i}>
                                                            <div className={Style.offerElement}>
                                                                <figure>
                                                                {item.image && item.image!=='undefined' ?
                                                                        (<img src={constants.IMAGE_BASE_URL+"business/"+item.image} alt={item.package} />):(<img src={PlaceholderImage} alt={item.package} />)}
                                                                </figure>
                                                                <div className={Style.offerTitle}>
                                                                    <h3>{item?.package}</h3>
                                                                    <h5>{item?.category}</h5>
                                                                </div>
                                                                <div className={Style.offerDetails}>
                                                                    <table role="none">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>Business Name</td>
                                                                                <td>{item?.company}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Category</td>
                                                                                <td>{item?.category}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>City</td>
                                                                                <td>{item?.city}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Country</td>
                                                                                <td>{item?.country}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                                <button type="button" onClick={()=>shoeOfferPopHandler(item)} className={Button.greenBtn + ' ' + Style.MoreDtl}>More Details</button>
                                                            </div>
                                                        </Col>
                                                        )}
                                                    )
                                                }
                                                

                                            </Row>
                                            {offerPopup &&
                                                <div className={Style.offerPopup}>
                                                    <div className={Style.offerElement}>
                                                        <button onClick={closeOfferHandler} className={Style.closePop}><IoMdClose /></button>
                                                        <figure>
                                                        {popupData.image && popupData.image!=='undefined' ?
                                                                (<img src={constants.IMAGE_BASE_URL+"business/"+popupData.image} alt={popupData.package} />):(<img src={PlaceholderImage} alt={popupData.package} />)}
                                                        </figure>
                                                        <div className={Style.offerTitle}>
                                                            <h3>{popupData.package}</h3>
                                                            <h5>{popupData.offerDescription}</h5>
                                                        </div>
                                                        <div className={Style.offerDetails}>
                                                            <table role="none">
                                                                <tr>
                                                                    <td>Business Name</td>
                                                                    <td>{popupData?.company}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Category</td>
                                                                    <td>{popupData?.category}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>City</td>
                                                                    <td>{popupData?.city}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Country</td>
                                                                    <td>{popupData?.country}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td  >Alumni Member Name</td>
                                                                    <td  >{popupData?.alumniName}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td  >Batch</td>
                                                                    <td  >{popupData?.batch}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td  >Designation</td>
                                                                    <td  >{popupData?.designation}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td  >Business Email Id</td>
                                                                    <td  >{popupData?.email}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td  >Business Contact Number</td>
                                                                    <td  > {popupData?.businessOfferContactNumber}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td  >Coupon Code</td>
                                                                    <td  >{popupData?.couponCode}</td>
                                                                </tr>
                                                            </table>
                                                        </div>
                                                        <button type="button" onClick={offerRequestHandler} className={Button.greenBtn + ' ' + Style.MoreDtl}>Avail Offer</button>
                                                    </div>
                                                </div>
                                            }

                                            {showOffer &&
                                                <div className={Style.offerPop}>
                                                    <div className={Style.offerContainer}>
                                                        {!sendRequest ?
                                                            <div className={Style.requestBox}>
                                                                <p>Your avail offer requset will be sent to the respective organisation. They will get in touch with you on the next steps.</p>
                                                                <div className={Style.ofrBtn}>
                                                                    <button type="button" onClick={()=>sendRequsetHandler(popupData)} className={Button.greenBtn + ' ' + Style.MoreDtl}>Send Request</button>
                                                                    <button type="button" onClick={closeOfferPop} className={Button.greenBtn + ' ' + Style.MoreDtl}>Cancel</button>
                                                                </div>
                                                            </div>
                                                            :
                                                            <div className={Style.requestBox}>
                                                                <p>Your request to avail offer has been sent to the respective organization. They will get in touch with you or you can contact them as per the contact details provided in the listing</p>
                                                                <div className={Style.ofrBtn}>
                                                                    <button type="button" onClick={closeOfferPop} className={Button.greenBtn + ' ' + Style.MoreDtl}>ok</button>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>                                            
                                            }

                                            <Row>
                                                <Col md={12}>
                                                <ul className={Button.flextCenterBtn + " " + Style.pagging}>
                                                            {[...Array(totalPages)].map((_, index) => (
                                                                <li key={index} >
                                                                    <button 
                                                                        type="butrton" 
                                                                        className={currentPage === index + 1 ? Style.activePage : Style.inactivePage} 
                                                                        onClick={() => handlePageChange(index + 1)}>
                                                                            {index + 1}
                                                                    </button>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
            : loginShow && <LoginPopup onClose={loginCloseHandler} /> }
        </div>
    )
}

export default OfferPage;